<template>
    <div>
        <div class="flex justify-center w-full">
            <custom-tooltip bottom border>
                <app-button icon circle @click="openNewFilter">
                    <img
                        src="@/assets/images/filter.svg"
                        height="15"
                        width="15"
                        alt="reload img"
                    />
                </app-button>
                <template #tooltip> Modificar filtros de búsqueda </template>
            </custom-tooltip>
        </div>
        <div class="flex flex-wrap w-full">
            <div
                v-if="activeFilters.includes('createdAt')"
                class="w-full px-2 mt-1"
            >
                <dates-filter
                    v-model="createdAt"
                    title="Filtro de fecha de creación"
                    :allow-future-dates="false"
                    default-mode="relative"
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('deliveryAt')"
                class="w-full px-2 mt-1"
            >
                <dates-filter
                    v-model="deliveryAt"
                    title="Filtro de fecha de entrega"
                    allow-future-dates
                    default-mode="absolute"
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('uuid')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <barcode-scanner-input
                    v-model="uuid"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('id')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <custom-input
                    v-model="id"
                    type="text"
                    placeholder="ID"
                    class="mr-2"
                    @blur="applyFilter"
                    @enter="onEnter"
                >
                    <template #icon> 🔎 </template>
                </custom-input>
            </div>

            <div
                v-if="activeFilters.includes('customerId')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <customers-search
                    v-model="customer"
                    enabled
                    label="Cliente"
                    @input="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('deliveryStatus')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <delivery-status-selector
                    v-model="deliveryStatus"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('paymentStatus')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <payment-status-selector
                    v-model="paymentStatus"
                    enabled
                    @change="applyFilter"
                />
            </div>

            <div
                v-if="activeFilters.includes('origin')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <order-origin-selector
                    v-model="origin"
                    enabled
                    @change="applyFilter"
                />
            </div>
            <div
                v-if="activeFilters.includes('userId')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <users-search v-model="user" enabled @input="applyFilter" />
            </div>
            <div
                v-if="activeFilters.includes('sellerId')"
                class="md:w-6/12 px-2 w-full mx-auto mt-3"
            >
                <user-by-merchant-selector
                    v-model="seller"
                    enabled
                    fill
                    label="Vendedor"
                    @change="applyFilter"
                />
            </div>
            <div
                v-if="activeFilters.includes('supplyStoreId')"
                class="md:w-6/12 px-2 w-full mx-auto mt-2"
            >
                <stores-search
                    v-model="supplyStoreId"
                    enabled
                    @change="applyFilter"
                />
            </div>
        </div>

        <app-dialog v-model="isOpenModal" size="lg" @close="pushNewFilter">
            <template #header>
                <div class="flex items-center justify-between gap-4">
                    <h3 class="text-base font-semibold text-theme-base">
                        Selecciona los filtros
                    </h3>

                    <app-button @click="isOpenModal = false">
                        ✔️ Aplicar filtros ({{ filters.length }})
                    </app-button>
                </div>
            </template>
            <cards-selector v-model="filters" :base="baseFilters" />
        </app-dialog>
    </div>
</template>

<script>
import { ordersFilters } from "@/common/fields/filters-query";

import DeliveryStatusSelector from "@/components/orders/DeliveryStatusSelector.vue";
import OrderOriginSelector from "@/components/orders/OrderOriginSelector.vue";
import PaymentStatusSelector from "@/components/orders/PaymentStatusSelector.vue";
import AppDialog from "@/components/utils/AppDialog.vue";
import CardsSelector from "@/components/utils/CardsSelector.vue";
import CustomInput from "@/components/utils/CustomInput.vue";
import DatesFilter from "@/components/utils/DatesFilter.vue";

export default {
    name: "OrdersFilters",
    components: {
        AppDialog,
        CardsSelector,
        CustomInput,
        BarcodeScannerInput: () =>
            import("@/components/utils/BarcodeScannerInput.vue"),
        UsersSearch: () => import("@/components/users/UsersSearch.vue"),
        UserByMerchantSelector: () =>
            import("@/components/users/UserByMerchantSelector.vue"),
        CustomersSearch: () =>
            import("@/components/customers/CustomersSearch.vue"),
        StoresSearch: () => import("@/components/utils/StoresSearch.vue"),
        DatesFilter,
        DeliveryStatusSelector,
        PaymentStatusSelector,
        OrderOriginSelector
    },
    model: {
        prop: "itemsCurrent",
        event: "change"
    },
    props: {
        itemsCurrent: {
            default: () => ({}),
            type: Object,
            require: true
        },
        enabledFilters: {
            default: () => ["deliveryAt"],
            type: Array,
            require: true
        }
    },
    data: () => ({
        activeFilters: [],
        id: "",
        uuid: "",
        isOpenModal: false,
        deliveryStatus: "",
        paymentStatus: "",
        origin: "",
        createdAt: {}, // {begin: "2026-02-01", end: "2026-02-28"}
        deliveryAt: {}, // {begin: "2026-02-01", end: "2026-02-28"}
        user: { id: "", firstName: "", lastName: "" },
        seller: { id: "", firstName: "", lastName: "" },
        customer: { id: "", firstName: "", lastName: "" },
        supplyStoreId: "",
        filters: [],
        baseFilters: [],
        lastEmitted: null
    }),
    watch: {
        filters() {
            this.applyFilter();
        },
        enabledFilters(value) {
            this.setEnabledFilters(value);
        },
        itemsCurrent(value) {
            if (JSON.stringify(value) === this.lastEmitted) return;
            this.setInput(value);
        }
    },
    created() {
        this.setEnabledFilters(this.enabledFilters);
    },
    mounted() {
        this.setInput(this.itemsCurrent);
    },
    methods: {
        setInput(value) {
            const filters = Object.keys(value).filter(
                (k) =>
                    !["customerObject", "sellerObject", "type"].includes(k) &&
                    value[k] !== "" &&
                    value[k] !== undefined &&
                    value[k] !== null
            );
            const filtersWithDeliveryStatus = filters.includes("deliveryStatus")
                ? filters
                : [...filters, "deliveryStatus"];
            // `filtersWithDeliveryStatus` es un array nuevo en cada llamada:
            // solo reasignar si el contenido realmente cambió, para no
            // disparar el watcher de `filters` (y el `applyFilter()` que
            // dispara) en cada re-sincronización desde `itemsCurrent` —
            // eso re-emitiría `change` hacia el padre y volvería a cambiar
            // `itemsCurrent`, entrando en loop.
            if (
                JSON.stringify(this.activeFilters) !==
                JSON.stringify(filtersWithDeliveryStatus)
            ) {
                this.activeFilters = filtersWithDeliveryStatus;
            }
            if (
                JSON.stringify(this.filters) !==
                JSON.stringify(filtersWithDeliveryStatus)
            ) {
                this.filters = filtersWithDeliveryStatus;
            }
            if ("origin" in value) {
                this.origin = value.origin;
            }
            if ("deliveryStatus" in value) {
                this.deliveryStatus = value.deliveryStatus;
            }
            if ("paymentStatus" in value) {
                this.paymentStatus = value.paymentStatus;
            }
            if ("createdAt" in value) {
                this.createdAt = value.createdAt;
            }
            if ("deliveryAt" in value) {
                this.deliveryAt = value.deliveryAt;
            }
            if ("customerId" in value) {
                this.customer = value.customerObject || {
                    id: value.customerId,
                    firstName: "",
                    lastName: ""
                };
            }
            if ("sellerObject" in value) {
                this.seller = value.sellerObject;
            } else if ("sellerId" in value) {
                this.seller = {
                    id: value.sellerId,
                    firstName: "",
                    lastName: ""
                };
            }
            if ("supplyStoreId" in value) {
                this.supplyStoreId = value.supplyStoreId;
            }
        },
        openNewFilter() {
            this.isOpenModal = true;
        },
        pushNewFilter() {
            this.activeFilters = [...this.filters];
            this.applyFilter();
        },
        onEnter() {
            this.applyFilter();
            this.$emit("enter");
        },
        applyFilter() {
            const payload = {
                ...{
                    ...(this.activeFilters.includes("id")
                        ? { id: this.id }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("uuid")
                        ? { uuid: this.uuid }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("deliveryStatus") &&
                    this.deliveryStatus
                        ? { deliveryStatus: this.deliveryStatus }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("paymentStatus") &&
                    this.paymentStatus
                        ? { paymentStatus: this.paymentStatus }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("origin") && this.origin
                        ? { origin: this.origin }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("sellerId") &&
                    this.seller.id
                        ? { sellerId: this.seller.id }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("customerId") &&
                    this.customer.id
                        ? { customerId: this.customer.id }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("createdAt")
                        ? { createdAt: this.createdAt }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("deliveryAt")
                        ? { deliveryAt: this.deliveryAt }
                        : null)
                },
                ...{
                    ...(this.activeFilters.includes("supplyStoreId") &&
                    this.supplyStoreId
                        ? {
                              merchantId: this.supplyStoreId,
                              merchantType: "store"
                          }
                        : null)
                }
            };
            this.lastEmitted = JSON.stringify(payload);
            this.$emit("change", payload);
        },
        setEnabledFilters(value) {
            this.baseFilters = ordersFilters.filter((item) => {
                const hasPermission =
                    !item.permissions ||
                    item.permissions.every((permission) =>
                        this.$ability.hasPermission(permission)
                    );
                return (
                    value.includes(item.id) &&
                    (item.show === undefined || item.show) &&
                    hasPermission
                );
            });
        }
    }
};
</script>
